/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import template from './reference-data-page.component.html';

import {CategorySearchResource} from '../../../components/api/resources/resource/categories';
import {KeyValueSearchResource} from '../../../components/api/resources/resource/key-value-search';

interface ReferenceDataSearchMeta {
  pageSize: number;
  currentPage: number;
  resolved: boolean;
  changePage: () => void;
}

interface ReferenceDataSearchState {
  term: string;
}

@Component({
  standalone: false,
  selector: 'adn-reference-data-page',
  template
})
export class ReferenceDataPageComponent implements OnInit, OnDestroy {
  search: ReferenceDataSearchState = {term: ''};
  kvSearch: ReferenceDataSearchState = {term: ''};
  list: any = {searchResults: []};
  kvList: any = {searchResults: []};

  searchMeta: ReferenceDataSearchMeta = {
    pageSize: 50,
    currentPage: 1,
    resolved: true,
    changePage: () => this.searchCategories()
  };
  kvSearchMeta: ReferenceDataSearchMeta = {
    pageSize: 50,
    currentPage: 1,
    resolved: true,
    changePage: () => this.searchKeyValues()
  };

  private searchHookTimer: ReturnType<typeof setTimeout> | null = null;
  private kvSearchHookTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private readonly categorySearchResource: CategorySearchResource,
    private readonly keyValueSearchResource: KeyValueSearchResource,
    private readonly ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.searchCategories();
    this.searchKeyValues();
  }

  ngOnDestroy(): void {
    if (this.searchHookTimer) {
      clearTimeout(this.searchHookTimer);
    }
    if (this.kvSearchHookTimer) {
      clearTimeout(this.kvSearchHookTimer);
    }
  }

  searchCategories(newSearch = false): void {
    this.searchMeta.resolved = false;

    if (newSearch) {
      this.searchMeta.currentPage = 1;
    }

    this.categorySearchResource.query({
      q: this.search.term || '',
      pageSize: this.searchMeta.pageSize,
      page: this.searchMeta.currentPage - 1,
      origin: 'UPLOAD'
    }).then((page: any) => {
      this.ngZone.run(() => {
        this.list = page;
        this.searchMeta.resolved = true;
      });
    });
  }

  searchKeyValues(newSearch = false): void {
    this.kvSearchMeta.resolved = false;

    if (newSearch) {
      this.kvSearchMeta.currentPage = 1;
    }

    this.keyValueSearchResource.query({
      q: this.kvSearch.term || '',
      pageSize: this.kvSearchMeta.pageSize,
      page: this.kvSearchMeta.currentPage - 1
    }).then((page: any) => {
      this.ngZone.run(() => {
        this.kvList = page;
        this.kvSearchMeta.resolved = true;
      });
    });
  }

  searchHook(): void {
    if (this.searchHookTimer) {
      clearTimeout(this.searchHookTimer);
    }
    this.searchHookTimer = setTimeout(() => {
      this.ngZone.run(() => this.searchCategories(true));
    }, 1000);
  }

  kvSearchHook(): void {
    if (this.kvSearchHookTimer) {
      clearTimeout(this.kvSearchHookTimer);
    }
    this.kvSearchHookTimer = setTimeout(() => {
      this.ngZone.run(() => this.searchKeyValues(true));
    }, 500);
  }
}
